import React from 'react';

const IzinTidakMasuk = () => {
  return (
    <h1>Izin Tidak Masuk</h1>
  );
};

export default IzinTidakMasuk;





